<template>
  <div class="record-search" v-loading="loading" element-loading-text="拼命加载中">
    <div class="headLine">
      <img src="../leftAngle.png" alt="返回上一层" @click="backIndex"/>
      小剂量货位
    </div>
    <div class="search-result warpper">
      <ul class="result-content content">
        <li
          class="result-item"
          v-for="(item, index) in recordList"
          :key="index"
        >
          <div class="item-name">货位号：{{item.name}}</div>
          <div class="item-remark">
            是否启用：
            <el-tag v-if="item.isUse === 1">启用</el-tag>
            <el-tag v-else type="danger">停用</el-tag>
          </div>
          <div class="item-remark">内部编号：{{item.innerId}}</div>
          <div class="item-remark">备注：{{item.remarks}}</div>
          <div class="item-btn">
            <el-button class="btn" @click="check(item.id, item.name)">查看</el-button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popstateLock: 0,//是否监听物理返回键
      loading: false,
      page: 1, // 分页查询，第一次为1
      pullupMsg: '加载更多',
      isShowTips: false,
      warehouseName: null,
      recordList:[],
    };
  },
  created() {
    this.searchRecord();
  },
  watch: {
    popstateLock(val) {
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val) {
        this.addPopstate()
      } else {
        this.removePopstate()
      }
    }
  },
  destroyed() {
    this.removePopstate()
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
    // this.$nextTick(() => {
    //   this._initBScroll()
    // })
  },
  methods: {
    addPopstate() {
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate() {
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 返回上一层
    backIndex() {
      this.$router.replace({name: 'hyWarehousePage'})
    },
    //查看
    check(id, name) {
      this.$router.replace({
        name: 'dangerShelvesGoods',
        query: {
          dangerId: id,
          dangerName: name
        }
      })
    },
    searchRecord() {
      this.$http.httpGet('/app/laShelves/list', {}).then(res => {
        console.log(res)
        if (res.code === 0 && res.msg === 'success') {
          if (res.page && res.page.list) {
            this.recordList = res.page.list
          } else {
            this.$message.info('查无记录')
            this.recordList = []
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.record-search {
  margin: 0;
  padding: 50px 0 0;
  position: relative;
  width: 100%;
  .headLine {
    height: 50px;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 9;
    font-size: 16px;
    border-bottom: 1px #efefef solid;

    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .search-input {
    position: relative;
    margin: 0 0 20px;
    overflow: hidden;

    .search-wrapper {
      position: relative;
      padding: 15px 20px;

      .wrapper-input {
        box-sizing: border-box;
        width: calc(100% - 5rem);
        height: 4rem;
        line-height: 4rem;
        border-radius: 6px 0 0 6px;
        border: 1px solid #ddd;
        background-color: #fff;
        // display: inline-block;
        float: left;

        input {
          height: 3rem;
          width: calc(100% - 2rem);
          border: none;
          padding: 0.5rem 1rem;
          font-size: 1.6rem;
          outline-style: none;
          color: #333;
          background-color: transparent;
        }
      }

      .wrapper-icon {
        position: relative;
        background-color: rgba(245, 209, 7, 0.801);
        width: 5rem;
        height: 4rem;
        display: inline-block;
        line-height: 4rem;
        text-align: center;
        border-radius: 0 6px 6px 0;

        a {
          color: #333;

          i {
            font-size: 3rem;
            font-weight: bold;
          }
        }
      }
    }

    .search-select {
      display: flex;
      justify-content: space-between;
      text-align: center;
      padding: 0 20px 10px;

      .el-select {
        width: 100%;
      }
    }

    .search-btn {
      margin-top: 0;
      padding: 0 20px;

      button {
        height: 3.2rem;
        font-weight: 700;
        display: inline-block;
        width: 40%;
      }

      .btn-left {
        float: left;
        width: 48%;
        background-color: rgb(207, 0, 0);
      }

      .btn-right {
        float: right;
        width: 48%;
        background-color: rgb(6, 175, 6);
      }
    }
  }
  .search-result {
    position: relative;
    padding: 0;
    margin: 15px 0 0;
    //height: calc(100vh - 50px - 30px);
    width: 100%;
    // height: 100%;
    //overflow: hidden;
    .result-content {
      padding: 0 20px 15px;
      .result-item {
        position: relative;
        box-sizing: border-box;
        padding: 10px;
        border-radius: 0.5rem;
        margin-bottom: 15px;
        /*height: 12rem;*/
        background-color: #f2f6fc;
        color: #303133;
        font-size: 1.6rem;
        box-shadow: 0 0.3rem 0.5rem #eee;
        .item-name {
          position: relative;
          margin-bottom: 10px;
          height: 3rem;
          text-align: left;
          line-height: 3rem;
          font-size: 1.4rem;
          color: #000;
        }
        .item-remark {
          position: relative;
          margin-bottom: 5px;
          height: 3rem;
          text-align: left;
          line-height: 3rem;
          font-size: 1.4rem;
          color: #000;
        }
        .item-btn {
          position: relative;
          margin: 10px 0 5px;
          //height: 2rem;
          //line-height: 2rem;
          //font-size: 1.4rem;
          color: #000;
          button {
            //height: 3.2rem;
            font-weight: 700;
            width: 100%;
            background-color: #3A9DF2;
          }
          .btn-bottom { width: 98%;}
        }
      }
    }
  }
}

::v-deep .el-input__inner::-webkit-input-placeholder {
  color: #666;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.el-select-dropdown__item {
  font-size: 14px !important;
  line-height: 34px;
  padding: 0 20px;
}
</style>
